import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-expanded", "aria-controls"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "column-picker__head" }

import { computed, onMounted, onUnmounted, PropType, ref } from 'vue';
import CheckBox from '../checkbox/CheckBox.vue';
import ClearButton from '@/components/clear/ClearButton.vue';
import Cross from '../cross/Cross.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnPicker',
  props: {
  columnConfig: {
    type: Object as PropType<{ [key: string]: { displayName: string; visible: boolean } }>,
    required: true,
  },
  idPrefix: {
    type: String,
    default: 'column-picker',
  },
},
  setup(__props) {

const props = __props;

const isOpen = ref(false);
const computedColumnConfig = computed(() => props.columnConfig);
const menuId = computed(() => `${props.idPrefix}-menu`);
const pickerRef = ref<HTMLElement | null>(null);

const anyVisible = computed(() => {
  return Object.values(props.columnConfig).some(config => config.visible);
});

const clearAll = () => {
  Object.values(props.columnConfig).forEach(config => config.visible = false);
};

const togglePicker = () => {
  isOpen.value = !isOpen.value;
};

const closePicker = () => {
  isOpen.value = false;
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node | null;
  if (target && pickerRef.value && !pickerRef.value.contains(target)) {
    closePicker();
  }
};

const handleEscape = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closePicker();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true);
  document.addEventListener('keydown', handleEscape);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside, true);
  document.removeEventListener('keydown', handleEscape);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "column-picker",
    ref_key: "pickerRef",
    ref: pickerRef
  }, [
    _createElementVNode("button", {
      class: "button button--filter column-picker__toggle",
      "aria-expanded": isOpen.value,
      "aria-controls": menuId.value,
      onClick: togglePicker
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Välj kolumner", -1 /* HOISTED */)),
      _createElementVNode("span", {
        class: _normalizeClass(["column-picker__icon icon icon--arrow-down", { 'column-picker__icon--open': isOpen.value }]),
        "aria-hidden": "true"
      }, null, 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_1),
    _withDirectives(_createElementVNode("div", {
      id: menuId.value,
      class: "column-picker__menu"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Välj kolumner", -1 /* HOISTED */)),
        _createVNode(Cross, { onClick: closePicker })
      ]),
      (anyVisible.value)
        ? (_openBlock(), _createBlock(ClearButton, {
            key: 0,
            onClick: clearAll
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedColumnConfig.value, (config, dataKey) => {
          return (_openBlock(), _createElementBlock("li", { key: dataKey }, [
            _createVNode(CheckBox, {
              id: `${__props.idPrefix}-${dataKey}-checkbox`,
              modelValue: config.visible,
              "onUpdate:modelValue": ($event: any) => ((config.visible) = $event),
              label: config.displayName
            }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue", "label"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 8 /* PROPS */, _hoisted_2), [
      [_vShow, isOpen.value]
    ])
  ], 512 /* NEED_PATCH */))
}
}

})